import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Heart } from "lucide-react";

interface NamesStepProps {
  firstName: string;
  lastName: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}

const NamesStep = ({ 
  firstName, 
  lastName, 
  onFirstNameChange, 
  onLastNameChange, 
  onNext, 
  onBack 
}: NamesStepProps) => {
  const isValid = firstName.trim().length > 0 && lastName.trim().length > 0;

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="flex flex-col items-center text-center"
    >
      <div className="mb-6">
        <Heart className="w-12 h-12 text-primary mx-auto mb-4" />
        <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-2">
          Tell us about yourselves
        </h2>
        <p className="text-muted-foreground">
          We'd love to know who we'll be working with
        </p>
      </div>

      <div className="w-full max-w-md space-y-4 mb-8">
        <div className="space-y-2 text-left">
          <Label htmlFor="firstName">Your First Name</Label>
          <Input
            id="firstName"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder="Enter your first name"
            className="text-center md:text-left"
          />
        </div>
        
        <div className="space-y-2 text-left">
          <Label htmlFor="lastName">Partner's First Name</Label>
          <Input
            id="lastName"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder="Enter your partner's first name"
            className="text-center md:text-left"
          />
        </div>
      </div>

      <div className="flex gap-3 w-full max-w-md">
        <Button
          variant="outline"
          onClick={onBack}
          className="flex-1"
        >
          Back
        </Button>
        <Button
          onClick={onNext}
          disabled={!isValid}
          className="flex-1"
        >
          Continue
        </Button>
      </div>
    </motion.div>
  );
};

export default NamesStep;
